import { motion } from "framer-motion"

const slideImg = {
  show: {
    opacity: 1,
    scale: 1,
  },
  hide: {
    opacity: 0,
    scale: 0.5,
  },
}

const Culture = ({ slide }) => {
  return (
    <div className="culture" tabIndex={0}>
      <div className={`slide-img `}>
        <motion.img
          variants={slideImg}
          initial="hide"
          animate={"show"}
          transition={{ duration: 0.25 }}
          src={slide.img}
          alt=""
        />
      </div>
      <div className="slide-desc">
        <p className="slide-name">{slide.title}</p>
      </div>
      <button className="btn-cta culture">Read More</button>
    </div>
  )
}

export default Culture
